import axiosapi from "./axiosAPI";

// Get All Zones
export const getAllZones = async (
    setZones,
    setFetcherror,
) => {
    
	try{
		const res =await axiosapi.get("/zones");
        setZones(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Zones");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Zones");
		}
		
	}
	
};


// Get All Zones Per Country
export const getCountryZones = async (
    setZones,
    setFetcherror,
    pkid
) => {
    
	try{
		const res =await axiosapi.get(`/countryzones/${pkid}`);
        setZones(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Zones");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Zones");
		}
		
	}
	
};



// Get One Zone
export const getOneZone = async (
    pkid,
    setFetcherror,  
    setZone
    
)=>{
	try{
		const res =await axiosapi.get(`/zones/${pkid}`);
        setZone(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Zone");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Zone");
		}
		
	}
	
};


// Create New Zone
export const createZone = async (
    zone,
    setZone,
    setFetcherror,
    handleAllToasts,
    setZones

) => {


    if (!zone ) {
        handleAllToasts(2, "No Zone Provided"); 
            return; 
        }

    const PushItem = {
        name: zone,
        country_id:1
        };

    try{
        await axiosapi.post("/zones/",PushItem );
        setZone("");
        handleAllToasts(1, "Zone Created Successfully");
        getAllZones(setZones, setFetcherror);
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New Zone");
            handleAllToasts(2, "Could Not update The Zone");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New Zone");
            handleAllToasts(2, "Could Not update The Zone");
            
        }
        
    }
    
}


// Edit Existing Zone

export const editZone = async (
    zonepkid,
    zone,
    setZone,
    setFetcherror,
    handleAllToasts,
    setZones
              
        ) => {

            if (!zone) {
                handleAllToasts(2, "No Zone Name Provided"); 
                    return;  
                }

            const PushItem = {

                    id:zonepkid,
                    name: zone,
                };

            try{
                await axiosapi.patch("/zones/",PushItem );
                setZone("");
                handleAllToasts(1, "Zone Updated Successfully");
                getAllZones(setZones, setFetcherror);
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update Zone");
                    handleAllToasts(2, "Could Not Update Zone");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update Zone");
                    handleAllToasts(2, "Could Not Update Zone");
                    
                }
                
            }
            
};



// Delete Existing Zone.

export const deleteZone = async (
    zonepkid,
    setZones,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/zones/${zonepkid}`);
        let finalData = res.data.message;
        getAllZones(setZones, setFetcherror);
        handleAllToasts(1, "Zone Deleted Successfully");
        console.log("Deleted:", finalData);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete Zone");
            handleAllToasts(2,"Error: Could Not Delete Zone");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete Zone");
            handleAllToasts(2,"Error: Could Not Delete Zone");
		}
		
	}
	
};